import React from 'react';
import './Home.css';

function Home() {
    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                    <h1 className="hero-title">
                        <span className="gradient-text">Pika Pika</span>
                        <br />
                        AI Video Generator
                    </h1>
                    <p className="hero-subtitle">
                        Transform your imagination into stunning AI-generated videos and images
                    </p>
                    <div className="hero-buttons">
                        <a href="https://play.google.com/store/apps/details?id=com.mypikaapp&hl=ko"
                            className="btn btn-primary"
                            target="_blank"
                            rel="noopener noreferrer">
                            <span>📱</span> Download on Google Play
                        </a>
                    </div>
                </div>
                <div className="hero-animation">
                    <div className="floating-card card-1">🎬</div>
                    <div className="floating-card card-2">✨</div>
                    <div className="floating-card card-3">🎨</div>
                </div>
            </section>

            {/* Features Section */}
            <section className="features">
                <h2 className="section-title">Powerful AI Features</h2>
                <div className="features-grid">
                    <div className="feature-card">
                        <div className="feature-icon">🎥</div>
                        <h3>AI Video Generation</h3>
                        <p>Create stunning videos from text descriptions using advanced AI technology</p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">🖼️</div>
                        <h3>Image Creation</h3>
                        <p>Generate unique action figures and celebrity photos with AI</p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">⚡</div>
                        <h3>Lightning Fast</h3>
                        <p>Get your creations in seconds with our optimized AI models</p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">🎨</div>
                        <h3>Multiple Styles</h3>
                        <p>Choose from various artistic styles and templates</p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">🌟</div>
                        <h3>Celebrity Photos</h3>
                        <p>Create photos with your favorite celebrities using AI</p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">💾</div>
                        <h3>Save & Share</h3>
                        <p>Download your creations and share them with the community</p>
                    </div>
                </div>
            </section>

            {/* How It Works */}
            <section className="how-it-works">
                <h2 className="section-title">How It Works</h2>
                <div className="steps">
                    <div className="step">
                        <div className="step-number">1</div>
                        <h3>Choose Your Style</h3>
                        <p>Select from action figures, videos, or celebrity photos</p>
                    </div>
                    <div className="step">
                        <div className="step-number">2</div>
                        <h3>Describe Your Vision</h3>
                        <p>Enter a text description or upload a photo</p>
                    </div>
                    <div className="step">
                        <div className="step-number">3</div>
                        <h3>Generate with AI</h3>
                        <p>Our AI creates your masterpiece in seconds</p>
                    </div>
                    <div className="step">
                        <div className="step-number">4</div>
                        <h3>Download & Share</h3>
                        <p>Save to your gallery or share with the community</p>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta">
                <div className="cta-content">
                    <h2>Ready to Create Amazing Content?</h2>
                    <p>Join thousands of creators using Pika Pika AI</p>
                    <a href="https://play.google.com/store/apps/details?id=com.mypikaapp&hl=ko"
                        className="btn btn-secondary"
                        target="_blank"
                        rel="noopener noreferrer">
                        Get Started Now
                    </a>
                </div>
            </section>
        </div>
    );
}

export default Home;
